import classNames from 'classnames';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { debounce } from 'src/utils/perfomance';
import CustomPlaceholder from 'src/view/components/Controls/SearchInput/components/CustomPlaceholder/CustomPlaceholder';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';
import './style.scss';

export interface ISearchProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  loading?: boolean;
  placeholder?: string;
  customPlaceholder?: boolean;
  customPlaceholderIcon?: Icons;
  debounceDelay?: number;
  withResetIcon?: boolean;
  resetIconWithEmptyValue?: boolean;
  additionalCb?: () => void;
  //
  className?: string;
  inputClassName?: string;
  customPlaceholderClassName?: string;
  customPlaceholderIconSize?: number;
  customPlaceholderIconColor?: string;
  customPlaceholderIconClassName?: string;
  customPlaceholderTextClassName?: string;
  onChangeText: (text: string) => void;
  onReset?: () => void;
}

const SearchInput = ({
  loading,
  placeholder = '',
  customPlaceholder,
  customPlaceholderIcon,
  debounceDelay = 0,
  withResetIcon,
  resetIconWithEmptyValue,
  value,
  defaultValue,
  //
  inputClassName,
  customPlaceholderClassName,
  customPlaceholderIconSize,
  customPlaceholderIconColor,
  customPlaceholderIconClassName,
  customPlaceholderTextClassName,
  onChangeText,
  onReset,
  ...props
}: ISearchProps) => {
  const [hidePlaceholder, setHidePlaceholder] = useState<boolean>(Boolean(value || defaultValue));
  const [textValue, setTextValue] = useState<string | number | readonly string[] | undefined>(value || defaultValue);
  // const onChange = useCallback(
  //   (data: ChangeEvent<HTMLInputElement> | boolean) => {
  //     if (typeof data === 'boolean') {
  //       onChangeText('');
  //     } else {
  //       onChangeText(data.target.value);
  //     }
  //   },
  //   [onChangeText]
  // );

  useEffect(() => {
    if (value !== null && value !== textValue) {
      setTextValue(value);
      setHidePlaceholder(Boolean(value));
    }

    // WARNING !!! not add textValue in dependecies
  }, [value]);

  const onTextChangedWithDelay = useCallback(debounce(onChangeText, debounceDelay), [onChangeText, debounceDelay]);
  const onTextChangedWithoutDelay = useCallback(onChangeText, [onChangeText]);

  const handleTextChanged = useCallback(
    (data: ChangeEvent<HTMLInputElement> | null, clear?: boolean) => {
      let text: string;
      if (clear || !data) {
        text = '';
        onReset?.();
      } else {
        text = data?.target.value || '';
      }

      setTextValue(text);

      if (customPlaceholder) setHidePlaceholder(Boolean(text));
      if (debounceDelay) {
        onTextChangedWithDelay(text);
      } else {
        onTextChangedWithoutDelay(text);
      }
    },
    [onTextChangedWithDelay, onTextChangedWithoutDelay, debounceDelay, customPlaceholder]
  );
  return (
    <div className={`input-wrapper ${props.className || ''}`}>
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        value={textValue || ''}
        onChange={handleTextChanged}
        placeholder={customPlaceholder ? '' : localeStore.t(placeholder)}
        className={classNames('input-search', inputClassName, { 'input-search_with-close-icon': withResetIcon })}
      />
      {customPlaceholder && !hidePlaceholder ? (
        <CustomPlaceholder
          placeholder={placeholder}
          icon={customPlaceholderIcon}
          iconSize={customPlaceholderIconSize}
          iconColor={customPlaceholderIconColor}
          className={customPlaceholderClassName}
          iconClassName={customPlaceholderIconClassName}
          textClassName={customPlaceholderTextClassName}
        />
      ) : null}
      {withResetIcon && (textValue || resetIconWithEmptyValue) && !loading ? (
        <div className="input-close" onClick={() => handleTextChanged(null, true)}>
          <Icon name={Icons.CloseSmall} size={16} className="color-gray2 my-auto" />
        </div>
      ) : null}
      {loading ? (
        <div className="input-spinner">
          <Spinner color={theme.colors.gray} />
        </div>
      ) : null}
    </div>
  );
};

export default SearchInput;
